<template>
  <div class="previous-container" v-if="boards && boards.length">
    <div
      v-for="(board, index) in boards"
      :key="index"
      class="prev-card"
    >
      <div
        v-for="(guess, i) in board.guesses"
        :key="i"
        class="prev-row"
      >
        <span
          v-for="(ch, j) in guess.word"
          :key="j"
          class="prev-cell"
          :class="guess.statuses[j]"
        >
          {{ ch }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviousBoards",
  props: {
    boards: { type: Array, required: true }
  }
};
</script>

<style scoped>
.previous-container {
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.prev-card {
  background: #0e5569;
  padding: 8px 10px;
  border-radius: 12px;
}

.prev-row {
  display: flex;
}

.prev-cell {
  width: 16px;
  height: 18px;
  margin: 1px;
  font-size: 12px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.prev-cell.correct {
  background: var(--tile-correct);
  color: #154153;
}

.prev-cell.present {
  background: var(--tile-present);
}

.prev-cell.absent {
  background: #d63f35;
}
</style>
